module.exports = __webpack_public_path__ + "static/media/12.6b14a9f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/12.png
// module id = 649
// module chunks = 0